import React from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import AppApprover from '../AppApprover';
import HelpApp from '../Help/HelpApp';
import Charts from '../Charts/Charts';
import PMCharts from '../ProjectManager/PMCharts';
import { Layout } from '../components/Layout/Layout';
import { Overview } from '../_pages/Overview/Overview';
import { UserActiveRoute } from './components/UserActiveRoute';
import Configuration from '../Configuration/Configuration';
import { ProjectApproval } from '../_pages/ProjectApproval/ProjectApproval';
import { ProjectManagerRoute } from './components/ProjectManagerRoute';
import { useTimeUIConfig } from '../hooks/queries/useTimeUIConfig';
import { AccessDenied } from '../_pages/AccessDenied';

export const routePaths = {
    root: '/',
    approve: '/approve',
    projectApproval: '/project-approval',
    help: '/help',
    charts: '/charts',
    pmCharts: '/pm-charts',
    admin: {
        root: '/admin',
        users: '/admin/users',
        adminUsers: '/admin/admin-users',
        resourceoverview: '/admin/resourceoverview',
        delegates: '/admin/delegates',
        projects: '/admin/projects',
        sync: '/admin/sync',
        powerppm: '/admin/powerppm',
        powerhub: '/admin/powerhub',
        jiraupload: '/admin/jiraupload',
        importData: '/admin/import-data', // data-import or just import??
        systemInformation: '/admin/system-information',
        settings: '/admin/settings',
        timeEntryCorrections: '/admin/time-entry-corrections',
        configuration: {
            approver: '/admin/configuration/approver',
            period: '/admin/configuration/period',
            time: '/admin/configuration/time',
            version: '/admin/configuration/version',
            validation: '/admin/configuration/validation',
            help: '/admin/configuration/help',
            calendar: '/admin/configuration/calendar',
        },
    },
};

const FeatureRoute = ({ children }: { children: React.ReactNode }) => {
    const { config } = useTimeUIConfig();

    if (!config.approval.projectManagerApproval.enabled) {
        return <AccessDenied />;
    }

    return children ? <>{children}</> : <Outlet />;
};

export const Router: React.FC = () => {
    return (
        <Routes>
            <Route
                path="/"
                element={
                    <UserActiveRoute>
                        <Layout />
                    </UserActiveRoute>
                }
            >
                <Route index element={<Overview />} />
                <Route path="approve" element={<AppApprover />} />
                <Route
                    path="project-approval"
                    element={
                        <ProjectManagerRoute>
                            <FeatureRoute>
                                <ProjectApproval />
                            </FeatureRoute>
                        </ProjectManagerRoute>
                    }
                />
                <Route path="help" element={<HelpApp />} />
                <Route path="charts" element={<Charts />} />
                <Route path="pm-charts" element={<PMCharts />} />
                {/* check if user is admin or has permission delegates */}
                <Route path="admin/*" element={<Configuration />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
        </Routes>
    );
};
